import { Component } from 'react';
import Phaser from 'phaser';

import PageScene from '../scenes/PageScene';
import FlashcardScene from '../scenes/FlashcardScene';
import LoadingScene from '../scenes/LoadingScene';
import PageSceneBase from '../scenes/PageSceneBase';

import { iteamMenuModelInstance } from '../datamodel/datamodel';
import { iteamGameModelInstance } from '../datamodel/gamemodel';

function resizeGameContainerAndCanvas(game) {
    if (game === null) {
        return;
    }
    let iTeamInteractionContainer = document.getElementById('iTeamInteractionContainer');

    if (iTeamInteractionContainer.offsetWidth <= 0) { // resize during display none hack
        return;
    }

    let gameContainer = document.getElementById('gameContainer');


    gameContainer.style.width = `${iTeamInteractionContainer.offsetWidth}px`;
    gameContainer.style.height = `${iTeamInteractionContainer.offsetHeight}px`;
    if (gameContainer.childNodes.length > 0) {
        let child = gameContainer.childNodes[0];
        child.style.width = `${iTeamInteractionContainer.offsetWidth}px`;
        child.style.height = `${iTeamInteractionContainer.offsetHeight}px`;
    }
    game.canvas.width = iTeamInteractionContainer.offsetWidth;
    game.canvas.height = iTeamInteractionContainer.offsetHeight;
    game.config.width = iTeamInteractionContainer.offsetWidth;
    game.config.height = iTeamInteractionContainer.offsetHeight;
    game.scene.scenes.forEach(tmpScene => {
        tmpScene.config.width = iTeamInteractionContainer.offsetWidth;
        tmpScene.config.height = iTeamInteractionContainer.offsetHeight;
        if (tmpScene instanceof PageSceneBase) {
            if (tmpScene.pageImage !== null) {
                tmpScene.zoomRecalculate();
            }
        } else if (tmpScene instanceof FlashcardScene) {
            if (tmpScene.flashcardImage !== null) {
                tmpScene.zoomRecalculate();
            }
        } else {
            if (tmpScene.resizeHandler !== undefined) {
                tmpScene.resizeHandler();   
            }
        }
    });
}

class IteamInteractionContainer extends Component {

    constructor(props) {
        super(props);

        this.state = {
                resizeEnabled: true
            };


        this.mainMenuSectionItem = null;
        
        this.game = null;

        this.pageScene = null;
        this.flashcardScene = null;
        this.exerciseScene = null;
        this.gamesMenuScene = null;

        this.gameScenes = {
            fluorescent: []
        }


        this.setExerciseSceneHandler = this.setExerciseSceneHandler.bind(this);
        this.setExerciseAudioDMHandler = this.setExerciseAudioDMHandler.bind(this);
        this.setExerciseVideoDMHandler = this.setExerciseVideoDMHandler.bind(this);
        this.setPageAudioDMHandler = this.setPageAudioDMHandler.bind(this);
        this.successOpenPageCallBack = this.successOpenPageCallBack.bind(this);
        this.errorOpenPageCallBack = this.errorOpenPageCallBack.bind(this);
        this.navigateToChapterIndex = this.navigateToChapterIndex.bind(this);
        this.disableGameInputs = this.disableGameInputs.bind(this);
        this.enableGameInputs = this.enableGameInputs.bind(this);
        this.setResizeEnabled = this.setResizeEnabled.bind(this);
    }

    
    componentDidMount() {
        this.createPhaserGameCanvas();
        this.registerWindowResizeHandler();
    }

    loadBookContent(sectionItem) {
        this.mainMenuSectionItem = sectionItem;
        if (sectionItem.type === 'book') {
            if (sectionItem.bookDM === null || sectionItem.bookDM.runtime.currentPageModel === null) {
                iteamMenuModelInstance.findCurrentPageModelByPageNumber(sectionItem, this.successOpenPageCallBack, this.errorOpenPageCallBack);
            } else {
                this.successOpenPageCallBack(sectionItem.bookDM, sectionItem.bookDM.runtime.currentChapterModel, sectionItem.bookDM.runtime.currentPageModel);
            }
        } else if (sectionItem.type === 'game') {

            if (sectionItem.gameMenuDM === null) {
                iteamGameModelInstance.loadGameMenu(sectionItem, this.successOpenGamesMenuCallBack, null);
            } else {
                this.successOpenGamesMenuCallBack(sectionItem.gameMenuDM);
            }
 
        }
    }


    successOpenPageCallBack(bookDM, chapterDM, pageDM) {
        let units = this.mainMenuSectionItem.getUnitItems();
        if (this.props.setUnitsCallBack !== undefined) {
            this.props.setUnitsCallBack(units);
        }

        if (this.mainMenuSectionItem.bookDM !== null) {
            this.props.setHeaderTitleInfoCallback({sectiontitle: bookDM.title, chaptertitle: chapterDM.title, pagenumbers: pageDM.pageNumberRange});
        }

        let hasPageScene = false;
        let hasFlashcardScene = false;
        this.game.scene.scenes.forEach(tmpScene => {
            if (tmpScene instanceof PageScene) {
                hasPageScene = true;
            } else if (tmpScene instanceof FlashcardScene) {
                hasFlashcardScene = true;
            }
        });

        if (bookDM.config.flashcardMode) {
            if (hasPageScene) {
                this.game.scene.stop('PageScene');
            }

            if (!hasFlashcardScene) {
                this.game.scene.add('FlashcardScene', this.flashcardScene, true);
            } else {
                this.game.scene.start('FlashcardScene');
            }

            this.flashcardScene.loadFlashcardDM(pageDM);

            this.setPageAudioDMHandler(null);
            this.setPageVideoDMHandler(null);

            this.props.setToolbarContainerIsVisibleCallBack(false);
            resizeGameContainerAndCanvas(this.game); // required after toolbar hide/show


        } else {
            if (hasFlashcardScene) {
                this.game.scene.stop('FlashcardScene');
            }

            if (!hasPageScene) {
                this.game.scene.add('PageScene', this.pageScene, true);
            } else {
                this.game.scene.start('PageScene');
            }

            this.props.setToolbarContainerIsVisibleCallBack(true);
            resizeGameContainerAndCanvas(this.game);  // required after toolbar hide/show

            this.pageScene.loadPageDM(pageDM);

            if (pageDM.audios.length > 0) {
                let audioDM = pageDM.audios[0];
                this.setPageAudioDMHandler(audioDM);
            } else {
                this.setPageAudioDMHandler(null);
            }

            if (pageDM.videos.length > 0) {
                let videoDM = pageDM.videos[0];
                this.setPageVideoDMHandler(videoDM);
            } else {
                this.setPageVideoDMHandler(null);
            }    
        }
    }

    errorOpenPageCallBack(error) {
        console.log(error);
    }


    registerWindowResizeHandler() {
        window.onresize = () => {
            if (!this.state.resizeEnabled) {
                return;
            }
            resizeGameContainerAndCanvas(this.game);
        }
    }

    setExerciseSceneHandler(exerciseScene) {
        this.exerciseScene = exerciseScene;
        this.props.setIsExerciseModeActive(exerciseScene === null ? false : true);
    }

    setExerciseAudioDMHandler(audioDM) {
        this.props.setExerciseAudioDMHandler(audioDM);
    }

    setPageAudioDMHandler(audioDM) {
        this.props.setPageAudioDMHandler(audioDM);
    }

    setExerciseVideoDMHandler(videoDM) {
        this.props.setExerciseVideoDMHandler(videoDM);
    }

    setPageVideoDMHandler(videoDM) {
        this.props.setPageVideoDMHandler(videoDM);
    }


    createPhaserGameCanvas() {
        let DEFAULT_CONFIG = {
            width: 1920,
            height: 1080,
            gameScenesList: this.gameScenes,
            game: null
        };

        let pageScene = new PageScene({
            config: DEFAULT_CONFIG,
            setExerciseCloseCallback: this.props.setExerciseCloseCallback,
            setExerciseSceneHandler: this.setExerciseSceneHandler,
            setExerciseAudioDMHandler: this.setExerciseAudioDMHandler,
            setExerciseVideoDMHandler: this.setExerciseVideoDMHandler,
            setCloseDrawingThicknessMenuCallback: this.props.closeDrawingThicknessMenuCallback,
            setLinkUrlCallBack: this.props.setLinkUrlCallBack,
            setResizeEnabled: this.setResizeEnabled
        });

        this.pageScene = pageScene;

        let flashcardScene = new FlashcardScene({
            config: DEFAULT_CONFIG,
            setResizeEnabled: this.setResizeEnabled
        });

        this.flashcardScene = flashcardScene;


        let loadingScene = new LoadingScene({ config: DEFAULT_CONFIG });
    
        let config = {
            // WebGL (Web graphics library) JS API for rendering 2D and 3D graphics
            type: Phaser.CANVAS,
            ...DEFAULT_CONFIG,
            parent: 'gameContainer',
            transparent: false,
            resolution: window.devicePixelRatio,
            antialias: true,
            pixelArt: false,
            physics: {
                // Arcade physics plugin, manages physics simulation
                default: 'arcade',
                arcade: {
                    debug: true
                }
            },
            dom: {
                createContainer: true
            },
            scene: [loadingScene],
            scale: {
                mode: Phaser.Scale.RESIZE
            },
            callbacks: {
                postBoot: function postBootCallbackFunc(game) {
                    resizeGameContainerAndCanvas(game);
                }
            },
        };
    
        this.game = new Phaser.Game(config);
        DEFAULT_CONFIG.game = this.game;
    }

    disableGameInputs() {
        console.log('DISABLE GAME INPUTS ARE CALLED');
        if (this.game === null) {
            return;
        }
        this.game.input.enabled = false;
    }

    enableGameInputs() {
        console.log('ENABLE GAME INPUTS ARE CALLED');
        if (this.game === null) {
            return;
        }
        this.game.input.enabled = true;
    }

    navigateToPreviousPage() {

        if (this.mainMenuSectionItem === null) {
            return;
        }
        if (this.pausePageVideoCallBack !== undefined && this.props.pausePageVideoCallBack !== null) {
            this.props.pausePageVideoCallBack();
        }
        if (this.pausePageAudioCallBack !== undefined && this.props.pausePageAudioCallBack !== null) {
            this.props.pausePageAudioCallBack();
        }
        iteamMenuModelInstance.navigateToPrevPageModel(this.mainMenuSectionItem, this.successOpenPageCallBack, this.errorOpenPageCallBack);
    }

    navigateToNextPage() {
        if (this.mainMenuSectionItem === null) {
            return;
        }
        if (this.pausePageVideoCallBack !== undefined && this.props.pausePageVideoCallBack !== null) {
            this.props.pausePageVideoCallBack();
        }
        if (this.pausePageAudioCallBack !== undefined && this.props.pausePageAudioCallBack !== null) {
            this.props.pausePageAudioCallBack();
        }
        iteamMenuModelInstance.navigateToNextPageModel(this.mainMenuSectionItem, this.successOpenPageCallBack, this.errorOpenPageCallBack);
    }

    navigateToChapterIndex(index) {
        iteamMenuModelInstance.navigateToChapterIndex(this.mainMenuSectionItem, index, this.successOpenPageCallBack, this.errorOpenPageCallBack);
    }

    gotoPageNumber(number) {
        this.mainMenuSectionItem.bookDM.runtime.currentPageNumber = number;
        iteamMenuModelInstance.findCurrentPageModelByPageNumber(this.mainMenuSectionItem, this.successOpenPageCallBack, this.errorOpenPageCallBack);
    }

    setResizeEnabled(resizeEnabled) {
        this.setState({resizeEnabled: resizeEnabled});
    }

    render() {
        if (this.props.enableGameInputs) {
            this.enableGameInputs();
        } else {
            this.disableGameInputs();
        }

        return (
            <div id='iTeamInteractionContainer' className='iTeamInteractionContainer'>
                <div id="gameContainer" ></div>
            </div>
        );
    }
}


export default IteamInteractionContainer;
